import classNames from 'classnames'
import { IconSize } from '../icon'
import styles from './Tag.module.scss'
import type { TagProps } from './types'
import { TagStyle, TagVariant } from './types'

const Tag: React.FC<TagProps> = ({
  children,
  className,
  label,
  leadingIcon: LeadingIcon,
  rtl = false,
  style = TagStyle.neutral,
  variant = TagVariant.primary,
}: TagProps) => {
  return (
    <div
      className={classNames(styles['pintxo-tag'], 'pintxo-typography-caption-emphasis', className)}
      data-style={style}
      data-variant={variant}
      data-rtl={rtl}
    >
      {children || (
        <>
          {LeadingIcon && <LeadingIcon outline rtl={rtl} size={IconSize.small} />}
          {label}
        </>
      )}
    </div>
  )
}
export default Tag
